import { gql } from 'apollo-boost';

const manyQuery = gql`
  query gyms($trainers: Int) {
    gyms(trainers: $trainers) {
      id
      name
      city
      address
      phone
      createdAt
      status
      email
      administrator
      clubId
      club {
        id
        shortName
      }
    }
  }
`;

const oneQuery = gql`
  query gym($id: Int!) {
    gym(id: $id) {
      id
      name
      city
      address
      phone
      createdAt
      status
      email
      administrator
      clubId
      club {
        id
        shortName
      }
    }
  }
`;

export const createMutation = gql`
  mutation createGym($inputData: GymInputType!) {
    createGym(inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const updateMutation = gql`
  mutation updateGym($id: Int!, $inputData: GymInputType!) {
    updateGym(id: $id, inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const deleteMutation = gql`
  mutation deleteGym($id: Int!) {
    deleteGym(id: $id) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const getAnalytic = gql`
  query getAnalyticGym($inputFilter: GymAnalyticFilterInputObjectType) {
    analyticGym(inputFilter: $inputFilter) {
      allAthletes
      allContributionsCount
      allContributionsSum
    }
  }
`;

const GYMS = {
  manyQuery,
  oneQuery,
  createMutation,
  updateMutation,
  deleteMutation,
  getAnalytic,
};

export default GYMS;
